import React, { useCallback, useEffect, useState } from "react";
import { SpinningCircles } from "react-loading-icons";
import InfiniteScroll from "react-infinite-scroll-component";

import LatestHeader from "../components/LatestHeader";
import Seo from "../components/SEO";
import CategoryMenu from "../components/CategoryMenu";
import AdBanner from "../components/AdBanner";
import { getStringCategories } from "../utils/generalUtils";
import "../styles/style.scss";

import APP_STORE from "../images/store/app_store.svg";
import PLAY_STORE from "../images/store/play_store.svg";
import ARROW_TOP from "../images/arrow_top_blue.svg";
import ARROW from "../images/arrow_left.svg";

const HomePage = () => {
	const [latestPets, setLatestPets] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setLoading] = useState(true);
	const [hasMorePage, setHasMorePage] = useState(true);
	const [categoryOptions, setCategoryOptions] = useState([]);

	const onFetchLatestPets = useCallback(
		async (categories = [], page = 1, updateCategory = false) => {
			try {
				if (page === 1) {
					setLoading(true);
					setHasMorePage(true);
				}
				const stringCategories = getStringCategories(categories);
				const categoryQuery = stringCategories === "all" ? "" : `&category_id=${stringCategories}`;
				const limit = 20;
				const offset = limit * (page - 1);

				const pets = await (
					await fetch(
						`https://shackpets.shacknews.com/api/pet-images?limit=${limit}&offset=${offset}&${categoryQuery}`
					)
				).json();

				setLatestPets((latestPets) => (page === 1 ? pets : [...latestPets, ...pets]));
				setCurrentPage(page + 1);
				if (!pets?.length) setHasMorePage(false);
				if (updateCategory) setCategoryOptions(categories);
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	const onScrollTop = useCallback(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	useEffect(() => {
		const categories = JSON.parse(localStorage.getItem("category-option") || "[]");
		onFetchLatestPets(categories, 1);
		setCategoryOptions(categories);
	}, [onFetchLatestPets]);

	return (
		<>
			<Seo title="Latest Pets" />
			<LatestHeader />

			<div id="latest-body" className="latest-layout">
				<section className="latest-section">
					<section className="mobile-top-banner-section">
						<AdBanner />
					</section>
					<div className="sticky-header" />
					<div className="filter-header">
						<p>Latest Pets</p>
						<CategoryMenu onFetchLatestPets={onFetchLatestPets} />
					</div>

					{isLoading ? (
						<div className="app-loading">
							<SpinningCircles stroke="#e76e8e" fill="#e76e8e" height="3rem" />
						</div>
					) : (
						<InfiniteScroll
							className="latest-pets-wrapper"
							dataLength={latestPets}
							next={() => {
								setTimeout(() => {
									onFetchLatestPets(categoryOptions, currentPage);
								}, 500);
							}}
							hasMore={hasMorePage}
							loader={
								<div className="load-more-loading">
									<SpinningCircles stroke="#e76e8e" fill="#e76e8e" height="2rem" />
								</div>
							}
						>
							{latestPets.length ? (
								latestPets.map(({ id, pet, image_url }, index) => (
									<div key={`${id}-${index}`} className="pet-card">
										<img src={image_url} alt="pet" />
										<p className="title">{pet?.name}</p>
										<p className="about">{pet?.about}</p>
									</div>
								))
							) : (
								<div className="app-loading">
									<h4>No Latest Pets</h4>
								</div>
							)}
						</InfiniteScroll>
					)}
				</section>

				<section className="side-banner-section">
					<AdBanner />
				</section>
			</div>

			<footer className="latest">
				<div className="primary">
					<button onClick={onScrollTop}>
						<span>Back to Top</span>
						<img className="arrow-top" src={ARROW_TOP} alt="icon" />
					</button>
				</div>

				<div className="secondary">
					<a
						className="footer-fab latest"
						href="https://www.shacknews.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src={ARROW} alt="arrow" />
						<span>Back to Shacknews</span>
					</a>

					<a
						className="header-store-menu"
						href="https://apps.apple.com/us/app/shackpets/id1535878997"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src={APP_STORE} alt="app-store" />
					</a>
					<a
						className="header-store-menu"
						href="https://play.google.com/store/apps/details?id=com.shacknews.shackpets"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src={PLAY_STORE} alt="play-store" />
					</a>
				</div>
			</footer>
		</>
	);
};

export default HomePage;
